import { Plus } from "lucide-react";
import {
  PERMIT_ADDONS,
  PERMIT_ADDON_PRICING,
  calculateAddOnPrice,
} from "../data/staticData";
import AddOnCard from "./AddOnCard";

function AddOnSummary({ selected, pricing }) {
  return (
    <div
      data-testid="addon-summary"
      className="mt-5 border-l-2 border-[#7CFF00] bg-[#0A0A0A] px-5 py-4 flex flex-wrap items-center justify-between gap-3"
    >
      <div className="flex items-center gap-2 flex-wrap">
        <span className="overline text-[10px]">// Selected Add-Ons</span>
        {selected.map((code) => (
          <span
            key={code}
            className="font-mono-tactical text-[10px] tracking-widest uppercase px-2 py-1 border border-[#7CFF00] text-[#7CFF00] bg-[#7CFF00]/10"
          >
            {code}
          </span>
        ))}
      </div>
      <div className="flex items-baseline gap-3">
        {pricing.isBundle && (
          <span
            data-testid="addon-bundle-savings"
            className="text-[10px] font-mono-tactical uppercase tracking-widest text-[#7CFF00]"
          >
            Bundle • Save ${PERMIT_ADDON_PRICING.bundleSavings}
          </span>
        )}
        <span className="overline text-[10px]">Add-On Total</span>
        <span
          data-testid="addon-total-price"
          className="font-tactical text-2xl text-[#7CFF00] font-bold tracking-tight glow-text"
        >
          +${pricing.total}
        </span>
      </div>
    </div>
  );
}

export default function PermitAddOnSelector({ selected, onToggle }) {
  const pricing = calculateAddOnPrice(selected);

  return (
    <div
      data-testid="permit-addon-selector"
      className="mt-10 max-w-5xl mx-auto"
    >
      <div className="flex items-start gap-3 mb-5">
        <Plus className="w-4 h-4 text-[#7CFF00] mt-1 flex-shrink-0" />
        <div>
          <div className="overline text-[10px] mb-1">// Add-On Upgrades</div>
          <p className="text-sm text-zinc-300 leading-relaxed max-w-2xl">
            {PERMIT_ADDON_PRICING.introHelper}
          </p>
        </div>
      </div>

      <div
        className="grid grid-cols-2 md:grid-cols-4 gap-3"
        data-testid="permit-addon-grid"
      >
        {PERMIT_ADDONS.map((addon) => (
          <AddOnCard
            key={addon.code}
            addon={addon}
            isSelected={selected.includes(addon.code)}
            onToggle={onToggle}
          />
        ))}
      </div>

      <p
        data-testid="addon-bundle-helper"
        className="mt-4 text-xs font-mono-tactical uppercase tracking-widest text-zinc-400"
      >
        <span className="text-[#7CFF00]">// </span>
        {PERMIT_ADDON_PRICING.bundleHelper}
      </p>

      {pricing.count > 0 && (
        <AddOnSummary selected={selected} pricing={pricing} />
      )}
    </div>
  );
}
